import React from "react";
import { DeviceEditPageHeaderTemplate } from "themes/application/device-settings/components";

class DeviceEditPageHeader extends React.Component {
    render() {
        return <DeviceEditPageHeaderTemplate {...this.props} />;
    }
}

export default DeviceEditPageHeader;